@import "../../css/button.css";
@import "../../css/spinner.css";

:host {
  all: initial;
  display: block;
  font-family: var(--zapier-font-family);
  color: var(--zapier-text);
  box-sizing: border-box;
}

:host([data-embed-mode="popup"]) {
  height: 100vh;
  overflow-y: auto;
  padding: calc(4 * var(--zapier-grid-unit)) calc(2 * var(--zapier-grid-unit));
}

:host([data-embed-mode="popup"])
  > :is(.account, .zaps-container, .zaps-pagination-container) {
  margin: 0 auto;
  max-width: 800px;
}

.allow-cookies {
  margin-top: var(--zapier-grid-unit);
}

.sign-in-container {
  display: flex;
  flex-flow: column;
  gap: calc(var(--zapier-grid-unit) * 2);
  box-sizing: border-box;
}

.sign-in-title,
.zap-empty-title {
  margin: 0;
  font-size: var(--zapier-font-size-18px);
  font-weight: 700;
}

.sign-up-or-log-in-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--zapier-grid-unit);
}

.account {
  display: grid;
  grid-template-columns: max-content auto;
  grid-gap: var(--zapier-grid-unit);
  align-items: center;
  justify-content: flex-end;
}

.account-info {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--zapier-avatar-text);
  background-color: var(--zapier-avatar-bg);
}

.account-info,
.account-info img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.zaps-container {
  /* Don't use margin here! We calculate the iframe height via JS, and Safari
  doesn't count top level margin in the elements height, for some reason... */
  margin: 0;
  padding: 0;
  padding-top: calc(2 * var(--zapier-grid-unit));
  padding-bottom: var(--zapier-grid-unit);
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: calc(1.5 * var(--zapier-grid-unit));
}

.zap-empty-container {
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-bottom: calc(var(--zapier-grid-unit) * 2);
  text-align: center;
}

.zap-empty-subtitle {
  margin: 0;
  margin-top: var(--zapier-grid-unit);
  font-size: var(--zapier-font-size-16px);
}

[slot="footer-start"] {
  pointer-events: none;
  display: flex;
  grid-area: footer-start;
  align-items: center;
  justify-content: start;
  font-size: var(--zapier-font-size-14px);
}

[slot="footer-end"] {
  display: flex;
  justify-self: end;
  grid-area: footer-end;
}

[slot="footer-end"] a {
  pointer-events: auto;
  position: relative;
}

.zap-footer a::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  margin-left: -10px;
  margin-top: -10px;
  width: calc(100% + 20px);
  height: calc(100% + 20px);
}

.zap-footer .account-info,
.zap-footer .account-info img {
  width: 20px;
  height: 20px;
}

.zap-owner-name {
  margin-left: calc(0.5 * var(--zapier-grid-unit));
}

.zap-history-link {
  display: flex;
  align-items: center;
  color: var(--zapier-text);
  font-weight: 600;
  text-decoration: none;
  border-radius: 3px;
  padding: 4px;
}

.zap-history-link svg {
  width: 15px;
  height: 15px;
  margin-right: 7px;
  fill: var(--zapier-icon-color);
}

.zap-history-link:focus-visible svg,
.zap-history-link:hover svg {
  fill: var(--zapier-brand);
}

.zap-history-link:focus,
.zap-history-link:hover {
  color: var(--zapier-brand);
}

.zap-history-link:focus-visible {
  color: var(--zapier-brand);
  outline: 2px solid;
}

.zaps-pagination-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.zaps-count {
  align-self: center;
}

.iframe {
  display: block;
  border: 0;
  width: 100%;
  box-sizing: border-box;
}

.popup-blocked {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 150ms linear;
}

[data-loading] {
  opacity: 0.5;
  transition: opacity 150ms linear;
}

@media (prefers-reduced-motion) {
  .loading-overlay {
    transition: none;
  }

  [data-loading] {
    transition: none;
  }
}

.loading-overlay[hidden] {
  opacity: 0;
  pointer-events: none;
}

/* Match height of buttons to avoid layout reflow */
.spinner {
  width: 42px;
  height: 42px;
}
